<template>
  <rest-list :payload="listEndpoint">
    <rest-list-column
      prop="id"
      :title="$t('ActionTrigger_Field_Id')"
      :width="200"
    />

    <rest-list-column
      v-if="!campaignId"
      prop="campaign_title"
      :title="$t('ActionTrigger_Field_Campaign')"
      :min-width="300"
      :tooltip="true"
    />

    <rest-list-column-date
      prop="create_time"
      :title="$t('ActionTrigger_Field_CreateTime')"
      :width="showProfile ? 300 : null"
    />

    <rest-list-column
      prop="profile_id"
      :title="$t('ActionTrigger_Field_Profile')"
      :route="profileIdRoute"
      :min-width="300"
      v-if="showProfile"
    />
  </rest-list>
</template>

<script>
import RestListColumnDate from '@/common/components/rest/RestListColumnDate'
import RestList from '@/common/components/rest/RestList'
import RestListColumn from '@/common/components/rest/RestListColumn'
import { projectRoute, projectEndpoint } from '@/core/helpers'

export default {
  name: 'TriggersList',

  components: {
    RestList,
    RestListColumn,
    RestListColumnDate
  },

  props: {
    campaignId: {
      required: false
    },
    showProfile: {
      default: false
    }
  },

  computed: {
    listEndpoint() {
      if (this.campaignId) {
        return projectEndpoint({
          method: 'get',
          url: `action-triggers`,
          params: {
            campaign_id: this.campaignId,
            sort: '-create_time'
          }
        })
      } else {
        return projectEndpoint({
          method: 'get',
          url: `action-triggers`,
          params: {
            expand: 'campaign_title',
            sort: '-create_time'
          }
        })
      }
    }
  },

  methods: {
    profileIdRoute(row) {
      if (row.profile_id && this.$can('Profile::Read')) {
        return projectRoute({
          name: 'ProfileOverview',
          query: {
            profile_id: row.profile_id
          }
        })
      } else {
        return null
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/notifications-log/components/TriggersList.vue